import PropTypes from 'prop-types';
import React from 'react';
import About from './AboutPage';
import useHomeStyles from './assets/css/_home';
import MainBanner from './components/MainBanner';
import ScrollTop from './components/ScrollUp';
import SocialLinks from './components/SocialLinks';
import Testimonial from './components/Testimonials';
import { mainBanner } from './components/theme/dataset';
import Contact from './ContactPage';
import Portfolio from './PortfolioPage';
import Services from './ServicesPage';
import WhyChooseUs from './WhyChooseUs';

// Visual section divider component
const SectionDivider = () => (
  <div className="section-divider" aria-hidden="true" />
);

export default function Home(props) {
  const classes = useHomeStyles();
  const { themeTitle } = props;

  return (
    <div className={classes.Home}>
      <MainBanner post={mainBanner} />
      
      <About
        title={`About ${themeTitle}`}
        description="Cybros.Dev is a cutting-edge software development firm specializing in AI-powered web applications and enterprise solutions. We combine deep technical expertise with innovative thinking to deliver scalable, intelligent systems that drive business transformation. From machine learning models to full-stack development, we architect solutions that position our clients at the forefront of technological innovation."
      />
      
      <SectionDivider />
      
      <Services
        title="Our Expertise"
        description="We deliver comprehensive technology solutions powered by artificial intelligence and modern software engineering practices. Our team of experts transforms complex business challenges into elegant, scalable applications."
      />

      <SectionDivider />

      <Portfolio title={`${themeTitle} Portfolio`} description="Recent Projects We've Completed For Our Clients" />
      
      <WhyChooseUs />

      <SectionDivider />

      <Testimonial />

      <SectionDivider />

      <Contact
        title="Contact Us"
        description="Fill out the form and our team will be in touch with you promptly."
        email="Or Email us at info@cybros.dev"
        thanks="Thank you for your interest!"
      />

      <SocialLinks />

      <ScrollTop />
    </div>
  );
}

Home.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
};
